// extracted by mini-css-extract-plugin
export default {"input":"input_input__23xip","select":"input_select__lMBWn","wrapper":"input_wrapper__FWtd3","padding":"input_padding__7Lrc7","error":"input_error__2gw9F"};